import {FormControl, MenuItem, OutlinedInput, Select} from "@mui/material";

import {useTranslation} from "react-i18next";

import React, {useEffect} from "react";

export default function LanguageSelector() {
  const {t, i18n} = useTranslation();

  const [language, setLanguage] = React.useState('');

  useEffect(() => {
    if (i18n.resolvedLanguage === "de") {
      setLanguage("de")
    } else {
      setLanguage("en")
    }
  }, []);

  const handleChange = (event) => {
    setLanguage(event.target.value);
    i18n.changeLanguage(event.target.value);
  };

  return (
    <FormControl sx={{ width: 'auto', flexShrink: 0 }}>
      <span
        id="language-select-label"
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        {t('language.label')}
      </span>
      <Select
        labelId="language-select-label"
        id="language-select"
        value={language}
        onChange={handleChange}
        IconComponent={() => null}
        input={
          <OutlinedInput
            notched={false}
            sx={{
              backgroundColor: '#EDF4F9',
              borderRadius: 0,
              height: 36,
              fontSize: 13,
              fontWeight: 500,
              minWidth: 0,
              '& .MuiSelect-select': {
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '12px',
                paddingRight: '12px !important',
                minWidth: 0,
              },
              '& fieldset': {
                borderColor: '#CCDBE6',
              },
              '&:hover fieldset': {
                borderColor: '#0063a6',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#0063a6',
              },
            }}
          />
        }
      >
        <MenuItem value="de">
          <img
            width="20"
            src="/flags/de.png"
            alt=""
          />&nbsp;Deutsch
        </MenuItem>
        <MenuItem value="en">
          <img
            width="20"
            src="/flags/gb.png"
            alt=""
          />&nbsp;English
        </MenuItem>
      </Select>
    </FormControl>
  )
}
